import React, { PureComponent } from 'react';
import cx from 'classnames';

const publication = ARTICLE_CONFIG.quizId || 'morgenpost';
const USE_LOCAL_IMAGES = true;

function bufferImage(src) {
  const img = new Image();

  img.src = src;
  img.onload = () => {};
}

function getLocalImages({ __id }) {
  return {
    questionSrc: `./images/maps/${publication}/question-${__id}.jpg`,
    answerSrc: `./images/maps/${publication}/answer-${__id}.jpg`,
  };
}

function getAPIImages({ center, zoom, size }) {
  const sizeParam = size ? `${size}x${size}`: '600x600';
  const questionSrc = `https://maps.tilehosting.com/c/a0a037d7-f288-42a8-88cf-666cf06cee7a/styles/gebaeude-umrisse/static/${center[0]},${center[1]},${zoom}/${sizeParam}.jpg?key=68ErAz6zqgdV9jEjhpuz`;
  const answerSrc = `https://maps.tilehosting.com/c/a0a037d7-f288-42a8-88cf-666cf06cee7a/styles/gebaeude-umrisse-9156c/static/${center[0]},${center[1]},${zoom}/${sizeParam}.jpg?key=68ErAz6zqgdV9jEjhpuz`;

  return { questionSrc, answerSrc };
}

class QuizMap extends PureComponent {
  constructor() {
    super();

    this.images = {};
  }

  componentDidUpdate(prevProps) {
    if (!this.props.isVisible || prevProps.isVisible) {
      return false;
    }

    this.images = USE_LOCAL_IMAGES ? getLocalImages(this.props) : getAPIImages(this.props);

    bufferImage(this.images.answerSrc);

    this.forceUpdate();
  }

  render() {
    const { finished, isVisible } = this.props;
    const containerClasses = cx('quiz-image-container', { finished });

    return (
      <div className={containerClasses}>
        {isVisible && <div className="quiz-image" style={{ backgroundImage: `url(${this.images.questionSrc})`, opacity: finished ? 0 : 1 }} />}
        {isVisible && <div className="quiz-image quiz-image--finished" style={{ backgroundImage: `url(${this.images.answerSrc})`, opacity: finished ? 1 : 0 }} />}
      </div>
    );
  }
}

export default QuizMap;
